//Usage:
//To get Cookie value: Hsn.Com.Cookie('name').Value();
//To set Cooke value:
//      Hsn.Com.Cookie('name').Set('value');
//      Hsn.Com.Cookie('name').Set('value', expiresInDays);
//
//To get Crumb value: Hsn.Com.Cookie('name').Crumb('name').Value();
//To set Crumb value:
//      Hsn.Com.Cookie('name').Crumb('name').Set('value');
//      Hsn.Com.Cookie('name').Crumb('name').Set('value', expiresInDays);
window.CookieAccessor = function (CookieName) {
    if (!CookieName) { throw new Error(1000, "CookieName is " + CookieName); }
    var search = CookieName + "=";
    var cookie = null;
    if (document.cookie.length > 0) {
        var offset = document.cookie.indexOf(search)
        // if cookie exists
        if (offset != -1) {
            offset += search.length
            // set index of beginning of value
            var end = document.cookie.indexOf(";", offset);
            // set index of end of cookie value
            if (end == -1) end = document.cookie.length;
            cookie = unescape(document.cookie.substring(offset, end));
        }
    };

    function _getExpires(expire) {
        var date = new Date();
        var days = (1000 * 60 * 60 * 24);
        return (new Date(date.getTime() + ((expire ? expire : 7) * days)));
    };

    return {
        Delete: function () {
            var expires = new Date();
            expires.setTime(expires.getTime() - 1);
            document.cookie = CookieName += "=;path=/;domain=.hsn.com;expires=" + expires.toGMTString();
        },
        Value: function () { return cookie; },
        Set: function (value, expire) {
            document.cookie = CookieName + "=" + value + ";path=/;domain=.hsn.com" +
                (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
        },
        Crumbs: function () {
            var crumbNames = [];
            var crumbs = cookie.split('&');
            crumbs.each(function (crumb) {
                crumbNames.push(crumb.split('=')[0]);
            });
            return crumbNames;
        },
        Crumb: function (CrumbName) {
            if (!CrumbName) { throw new Error(1000, "CrumbName is " + CrumbName); }
            return {
                Delete: function () {
                    if (!cookie) { return; }
                    var idx = cookie.indexOf(CrumbName);
                    if (idx > -1) {
                        var replacement = cookie.substr(idx);
                        idx = replacement.indexOf('&');
                        if (idx > -1) { replacement = replacement.substr(0, idx); }
                        cookie = cookie.replace(replacement, '');
                    }
                    document.cookie = CookieName + "=" + cookie
                },
                Set: function (value, expire) {
                    if (!cookie) {
                        document.cookie = CookieName + "=" + CrumbName + "=" + value + ";path=/;domain=.hsn.com" + (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
                    } else {
                        var idx = cookie.indexOf(CrumbName);
                        if (idx > -1) {
                            var replacement = cookie.substr(idx);
                            idx = replacement.indexOf('&');
                            if (idx > -1) { replacement = replacement.substr(0, idx); }
                            cookie = cookie.replace(replacement, CrumbName + "=" + value);
                        } else {
                            cookie += "&" + CrumbName + "=" + value;
                        }
                        document.cookie = CookieName + "=" + cookie + ";path=/;domain=.hsn.com" + (expire ? ";expires=" + _getExpires(expire).toUTCString() : "");
                    }
                },
                Value: function () {
                    var ret = null;
                    if (cookie && cookie.length > 0) {
                        var crumbs = cookie.split('&');
                        if (crumbs.length > 0) {
                            for (var i = 0; i < crumbs.length; i++) {
                                var values = crumbs[i].split('=');
                                if (values[0] === CrumbName) {
                                    ret = values[1];
                                }
                            }
                        }
                    }
                    return ret;
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/CookieAccessor.js